import React from 'react';
import { Link } from 'react-router-dom';
import EditIcon from '../../../../assets/svg/edit.svg';
import SettingsIcon from '../../../../assets/svg/settings.svg';
import { BaseComponent } from '../../../../shared/BaseComponent';
import { ACL, UserCan } from '../../../../shared/constants';
import { getPersonAllowedSee } from '../../../../shared/db/general-db';
import {
  clientDefaultSettings,
  namingHelper,
} from '../../../../shared/helpers';
import * as structure from '../../../../shared/interfaces';
import TableSimple from '../../../elements/TableSimple';
import LocalPersonTile from '../LocalPeopleTile';
import styles from '../PersonTabPage.module.scss';

export class DefaultSettingsTile extends BaseComponent<
  { userCanDo; personId, editUrl },
  {
    allowed: structure.iItemsAllowed;
    defaultSettings: structure.iDefaultSettings;
    editUrl: string;
  }
> {
  async componentDidMount() {
    const { personId } = this.fullProps;

    this.setState({ allowed: await getPersonAllowedSee(personId) });
  }

  debugRender = () => {
    const { userCanDo, editUrl } = this.props;

    const isSetAllowed = !this.state || !this.state.allowed;
    const isSetDefaultSettings = !this.state || !this.state.defaultSettings;

    isSetDefaultSettings &&
      clientDefaultSettings((value) =>
        this.setState({ defaultSettings: value })
      );

    return (
      <LocalPersonTile
        collapsible
        initialCollapsed
        title='Default Settings'
        loading={isSetAllowed}
        action={
          !editUrl || !ACL.check(UserCan.DO_ANYTHING, userCanDo) ? undefined : (
            <Link to={editUrl}>
              <img src={EditIcon} alt='editIcon' className={styles.editIconStyle}/>
            </Link>
          )
        }
        leftIcon={null}
      >
        {isSetAllowed && isSetDefaultSettings ? null : (
          <TableSimple
            sm
            striped
            headers={['Name', 'Value']}
            style={{ fontSize: 11 }}
          >
            {Object.entries(this.state.defaultSettings || {})
              .filter(([, v]) => !(v !== null && typeof v === 'object'))
              .map((entrie) => (
                <tr key={entrie[0]}>
                  <td className={styles.tableItem}>{namingHelper(entrie[0])}</td>
                  <td className={styles.tableItem}>{String(entrie[1])}</td>
                </tr>
              ))}
          </TableSimple>
        )}
      </LocalPersonTile>
    );
  };
}
